import { createReducer } from '@reduxjs/toolkit';
import IProfileState from 'types/profile/IProfileState';
import {
  setProfileAction,
  updateLanguageErrorAction,
  setPasswordErrorAction,
  setProfileRequestsLoadingAction,
  setPasswordSuccessAction,
  updateLanguageSuccessAction,
  setHasSelectedCompany,
} from '../actions/profile-actions';

const initialState: IProfileState = {
  loading: false,
  data: null,
  updateLanguageSuccess: false,
  updateLanguageError: false,
  setPasswordSuccess: false,
  setPasswordError: false,
  hasSelectedCompany: false,
};

const profileReducer = createReducer(initialState, builder =>
  builder
    .addCase(setProfileAction, (state, action) => ({ ...state, data: action.payload }))
    .addCase(setProfileRequestsLoadingAction, (state, action) => ({ ...state, loading: action.payload }))
    .addCase(updateLanguageErrorAction, (state, action) => ({ ...state, updateLanguageError: action.payload }))
    .addCase(updateLanguageSuccessAction, (state, action) => ({ ...state, updateLanguageSuccess: action.payload }))
    .addCase(setPasswordSuccessAction, (state, action) => ({ ...state, setPasswordSuccess: action.payload }))
    .addCase(setPasswordErrorAction, (state, action) => ({ ...state, setPasswordError: action.payload }))
    .addCase(setHasSelectedCompany, (state, action) => ({
      ...state,
      hasSelectedCompany: action.payload,
    })),
);

export default profileReducer;
